import { z } from 'zod'

export const RECOGNITION_KEYS = [
  'clean_vehicle',
  'delivered_with_care',
  'extra_helpful',
  'fast_delivery',
  'friendly',
  'great_photo',
  'professional',
] as const

export type RecognitionKey = (typeof RECOGNITION_KEYS)[number]

const RecognitionKeySchema = z.enum(RECOGNITION_KEYS)

const RecognitionSchema = z.object({
  key: RecognitionKeySchema,
  title: z.string(),
  count: z.number(),
})

const SenderRecognitionsSchema = z.object({
  show_section: z.boolean(),
  recognitions: z.array(RecognitionSchema),
})

export const SenderRecognitionsResponseSchema = z.object({
  sender_recognitions: SenderRecognitionsSchema,
})

type SenderRecognitionsResponse = z.infer<typeof SenderRecognitionsResponseSchema>

export type Recognition = {
  key: RecognitionKey
  title: string
  count: number
}

export type SenderRecognitions = {
  showSection: boolean
  recognitions: Recognition[]
}

export const DEFAULT_SENDER_RECOGNITIONS: SenderRecognitions = {
  showSection: false,
  recognitions: [],
}

export type SenderRecognitionsData = {
  senderRecognitions: SenderRecognitions
}

export function deserializeSenderRecognitionsData(data: unknown): SenderRecognitionsData {
  const validatedData = data as SenderRecognitionsResponse

  const recognitions = validatedData.sender_recognitions.recognitions
    .map((recognition) => ({
      key: recognition.key,
      title: recognition.title,
      count: recognition.count,
    }))
    .filter((recognition) => recognition.count > 0)
    .sort((a, b) => b.count - a.count)

  return {
    senderRecognitions: {
      showSection: validatedData.sender_recognitions.show_section,
      recognitions,
    },
  }
}
